import { createSlice } from '@reduxjs/toolkit';

const initialStocksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  stockForView: undefined,
  error: null,
  msg: null,
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const stocksSlice = createSlice({
  name: 'stocks',
  initialState: initialStocksState,
  reducers: {
    catchError: (state, action) => {
      //state.error = `${action.type}: ${action.payload.error}`;
      state.error = `${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    sendMsg: (state, action) => {
      state.msg = `${action.payload.msg}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.msg = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findStocks
    stocksFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.msg = null;
      state.entities = entities;
      state.totalCount = totalCount;
      return state;
    },
    // getStockById
    stockFetched: (state, action) => {
      state.actionsLoading = false;
      state.stockForView = action.payload.stockForView;
      state.error = null;
      state.msg = null;
      return state;
    },
    // create stock
    stockCreated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.stockForView = action.payload.stockForView;
      return state;
    },

    // update stock
    stockUpdated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.stockForView = action.payload.stockForView;
      return state;
    },
    // delete stock
    stockDeleted: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
      return state;
    },
    // create stock
    stockCleared: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.stockForView = null;
      return state;
    },
  },
});
